export const InvestorColumns = [
  {
    id: "actions",
    title: "Actions",
  },
  {
    id: "name",
    title: "Name",
  },
  {
    id: "contact",
    title: "Contact",
  },
  {
    id: "email",
    title: "Email",
  },
  {
    id: "address",
    title: "Address",
  },
  {
    id: "total",
    title: "Total",
  },
  {
    id: "view_investment",
    title: "Investments",
  },
];
